/* Rediscover — footer "Ship to: <country>" selector behaviour.
   Markup rendered by snippets/rediscover-shipto.liquid; styles in assets/rediscover-shipto.css. */
(function () {
  function init() {
    var root = document.querySelector('[data-rdv-shipto]');
    if (!root || root.dataset.rdvBound) return;
    root.dataset.rdvBound = '1';

    var form = root.querySelector('.rdv-shipto__form');
    var input = root.querySelector('[data-rdv-input]');
    var ret = root.querySelector('[data-rdv-return]');
    var panel = root.querySelector('[data-rdv-panel]');

    function open() {
      root.classList.add('is-open');
      document.body.classList.add('rdv-shipto-lock');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('rdv-shipto-lock');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }

    root.querySelector('[data-rdv-open]').addEventListener('click', open);
    root.querySelector('[data-rdv-close]').addEventListener('click', close);
    root.querySelector('[data-rdv-overlay]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    root.querySelectorAll('[data-rdv-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('.rdv-shipto__group');
        var isOpen = g.getAttribute('data-open') === 'true';
        g.setAttribute('data-open', isOpen ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    root.querySelectorAll('.rdv-shipto__country').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (input) input.value = btn.getAttribute('data-value');
        if (ret) ret.value = window.location.pathname + window.location.search;
        form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
